import {
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { useForm } from "hooks/useForm";
import { useToggle } from "hooks/useToggle";
import React, { forwardRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { newContidion } from "redux/actions/conditionsCatalog/conditionsCatalog";
import { setSnackbar } from "redux/actions/search/searchActions";
import { CustomSelect } from "components/Select/CustomSelect";
import { editCondition } from "redux/actions/conditionsCatalog/conditionsCatalog";
import { Autocomplete } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import { validateObject } from "helpers/validateObject";
import { conditionMetricUnit } from "helpers/dictionary";


export const NewFormCondition = forwardRef((ref, props) => {
  const { close, edit, condition } = ref;
  const dispatch = useDispatch();
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    name: "",
    unitMetric: conditionMetricUnit[0],
    checked: false,
  });

  // const [unitsMetric, setUnitsMetric] = useState({});
  // const [checked, setChecked] = useState(false);
  const [block, dum, handleBlock] = useToggle();

  const { name, unitMetric, checked } = inputValues;

  const handleCheck = ({ target }) => {
    handleNewValues({
      ...inputValues,
      checked: target.checked,
    });
  };

  const handleChange = (e, v) => {
    const value = v ? v : {};
    handleNewValues({
      ...inputValues,
      unitMetric: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.length > 0 && validateObject(unitMetric)) {
      const form = {
        name,
        metricUnit: unitMetric.value,
        limited: checked,
      };
      edit
        ? dispatch(editCondition(condition.value, form))
        : dispatch(newContidion(form));
      close();
    } else {
      dispatch(setSnackbar("Seleccione al menos una Unidad"));
      return;
    }
  };

  useEffect(() => {
    if (name.length > 3) {
      handleBlock(false);
    } else {
      handleBlock(true);
    }
    //eslint-disable-next-line
  }, [name]);

  useEffect(() => {
    if (edit) {
      handleNewValues({
        name: condition.label,
        unitMetric: conditionMetricUnit.find((sym) => sym.value === condition.metricUnit),
        checked: condition.limited,
      });
      // setChecked(condition.limited);
      // setUnitsMetric(condition.metricUnit);
    }
    //eslint-disable-next-line
  }, []);

  return (
    <FormControl fullWidth>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Condición"
            variant="outlined"
            name="name"
            value={name}
            onChange={handleInputOnChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            id="conditions_:autoselect_"
            options={conditionMetricUnit}
            value={unitMetric}
            getOptionLabel={(option) =>
              option.label ? option.label : option.name
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option?.name ? option.name : option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidades Metricas"
                variant="outlined"
              />
            )}
            fullWidth
            onChange={(e, v) => handleChange(e, v)}
            noOptionsText="No se encuentra la Condición"
            closeIcon={
              <CloseIcon
                fontSize="small"
                style={{
                  marginRight: 24,
                }}
              />
            }
          />
          {/* <CustomSelect
        options={conditionMetricUnit}
        value={unitsMetric}
        variant="outlined"
        label="Unidades metricas"
        handleChange={({ target }) => setUnitsMetric(target.value)}
      /> */}
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={checked}
                onChange={handleCheck}
                name="no"
              />
            }
            label="Esta limitado a 1?"
            labelPlacement="start"
            style={{ margin: 0 }}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: "flex", flexDirection: 'column',
          gap: 8,
        }}
      >
        <RegularButton
          color="info"
          onClick={handleSubmit}
          disabled={block}
          fullWidth
        >
          {edit ? "Guardar" : "Crear"}
        </RegularButton>
        <RegularButton fullWidth color="danger" onClick={close}>
          Cancelar
        </RegularButton>
      </Grid>
    </FormControl>
  );
});
